export default __webpack_public_path__ + "668cd19b7b8629545969e0286b8b5104.png";